import axios from './base'
const url = ``

export function getList(data = {}) {
  return axios.request({
    url: `${url}/products`,
    method: "get",
    params: data,
  })
}
